module.exports = __webpack_public_path__ + "img/collage1.4044046c.jpg";